import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardHome from "./Home/DashboardHome";
import Inventory from "./Inventory/Inventory";
import {
  FaSignOutAlt,
  FaHome,
  FaBox,
  FaUsers,
  FaCog,
  FaTimes,
  FaBars,
  FaFileInvoice,
  FaReceipt,
  FaShoppingCart,
  FaTruck,
  FaTasks,
} from "react-icons/fa";
import { useAuth } from "./Context/AuthContext";
import Users from "./Users/Users";
import Settings from "./Home/Settings";
import Receipts from "./Receipts/Receipts";
import Invoices from "./invoices/Invoices";
import Spinner from "./Helpers/Spinner";
import LocalPurchaseOrders from "./LocalPurchaseOrders/LocalPurchaseOrders";
import DeliveryNotes from "./DeliveryNotes/DeliveryNotes";
import Tasks from "./Tasks";

function Home() {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(true);
  console.log("user");
  console.log(user);

  // const [selected, setSelected] = useState("Home");
  const [selected, setSelected] = useState(() => {
    return localStorage.getItem("selectedMenu") || "Home";
  });

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isAdmin = user?.role === "Admin";

  const menuItems = [
    {
      key: "Home",
      label: "Home",
      icon: <FaHome className="mr-2" />,
      content: <DashboardHome />,
    },
    {
      key: "Inventory",
      label: "Inventory",
      icon: <FaBox className="mr-2" />,
      content: <Inventory />,
    },
    ...(isAdmin
      ? [
          {
            key: "Users",
            label: "Users",
            icon: <FaUsers className="mr-2" />,
            content: <Users />,
          },
        ]
      : []),
    {
      key: "Tasks",
      label: "Tasks",
      icon: <FaTasks className="mr-2" />,
      content: <Tasks />,
    },
    {
      key: "Invoices",
      label: "Invoices",
      icon: <FaFileInvoice className="mr-2" />,
      content: <Invoices />,
    },
    {
      key: "Delivery Notes",
      label: "Delivery Notes",
      icon: <FaTruck className="mr-2" />,
      content: <DeliveryNotes />,
    },
    {
      key: "Receipts",
      label: "Receipts",
      icon: <FaReceipt className="mr-2" />,
      content: <Receipts />,
    },

    {
      key: "Local Purchase Order",
      label: "Local Purchase Order",
      icon: <FaShoppingCart className="mr-2" />,
      content: <LocalPurchaseOrders />,
    },
  ];

  const sidebarRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarOpen
      ) {
        setSidebarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  const handlelogout = async () => {
    setLoading(true);
    await logout();
    setLoading(false);
  };

  return (
    //   <div className="flex h-screen w-screen overflow-hidden">
    //     {/* Sidebar */}
    //     <div
    //       ref={sidebarRef}
    //       className={`bg-blue-100 flex flex-col absolute md:relative z-20 h-full transition-transform duration-300 ease-in-out
    // ${
    //   sidebarOpen ? "translate-x-0 w-2/3 sm:w-1/2" : "-translate-x-full"
    // } md:translate-x-0 md:w-1/5`}
    //     >
    //       {/* Header */}
    //       <div className="p-4 bg-blue-600 text-white shadow-md flex justify-between items-center">
    //         <h2 className="text-lg font-bold">Menu</h2>
    //         <button
    //           className="md:hidden text-sm"
    //           onClick={() => setSidebarOpen(false)}
    //         >
    //           ✕
    //         </button>
    //       </div>

    //       {/* Scrollable Menu */}
    //       <div className="flex-1 overflow-y-auto p-4 space-y-2">
    //         {menuItems.map((item) => (
    //           <button
    //             key={item.key}
    //             onClick={() => {
    //               setSelected(item.key);
    //               setSidebarOpen(false);
    //             }}
    //             className={`w-full text-left p-2 rounded flex items-center ${
    //               selected === item.key
    //                 ? "bg-blue-500 font-semibold text-white"
    //                 : "hover:bg-blue-100"
    //             }`}
    //           >
    //             {item.icon} {item.label}
    //           </button>
    //         ))}
    //       </div>

    //       {/* Footer */}
    //       <div className="p-4 bg-gray-100 shadow-sm flex flex-col items-start border-t border-gray-200">
    //         <p className="text-sm font-semibold text-gray-800">Kevmark © 2025</p>

    //         {/* Only show on small screens, in a column */}
    //         <div className="mt-2 space-y-2 md:hidden w-full">
    //           <span className="text-sm font-medium text-gray-600">
    //             {user?.name || null}
    //           </span>
    //           <button
    //             onClick={handlelogout}
    //             className="w-full text-left px-3 py-2 bg-gray-50 text-red-600 hover:text-red-700 hover:bg-gray-100 rounded-md flex items-center transition-all duration-200 ease-in-out"
    //           >
    //             <FaSignOutAlt size={18} className="mr-2" /> Logout
    //           </button>
    //         </div>
    //       </div>
    //     </div>

    //     {/* Main Content */}
    //     <div className="flex-1 bg-white flex flex-col h-full">
    //       {/* Header */}

    //       <div className="p-4 bg-blue-100 shadow-md flex items-center justify-between">
    //         <div className="flex items-center justify-between w-full">
    //           {/* <img src="/images/logo.png" alt="Logo" className="h-8 w-8 mr-2" /> */}
    //           <h2 className="text-lg font-bold">Inventory Manager</h2>

    //           {/* User info (hidden on small screens) */}
    //           <div className="hidden md:flex items-center space-x-4">
    //             <span className="text-gray-600 font-medium">
    //               {user?.name || null}
    //             </span>
    //             <button
    //               onClick={handlelogout}
    //               className="flex items-center text-red-600 hover:text-red-700 rounded-md"
    //             >
    //               <FaSignOutAlt size={18} className="mr-2" />
    //               Logout
    //             </button>
    //           </div>
    //         </div>

    //         {/* MENU toggle button (only on small screens) */}
    //         <button
    //           className="md:hidden text-blue-700"
    //           onClick={() => setSidebarOpen(true)}
    //         >
    //           <FaBars size={20} />
    //         </button>
    //       </div>

    //       {/* Scrollable Content */}
    //       <div className="flex-1 overflow-y-auto p-4">
    //         {menuItems.find((item) => item.key === selected)?.content}
    //       </div>
    //       {/* Footer */}
    //       {/* <div className="p-4 bg-blue-100 shadow-inner">
    //         <p>Main Footer</p>
    //       </div> */}
    //     </div>
    //   </div>
    <div className="flex h-screen w-screen overflow-hidden">
      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`bg-brand-light flex flex-col absolute md:relative z-20 h-full transition-transform duration-300 ease-in-out
      ${sidebarOpen ? "translate-x-0 w-2/3 sm:w-1/2" : "-translate-x-full"}
      md:translate-x-0 md:w-1/5`}
      >
        {/* Header */}
        {/* <div className="p-4 bg-brand-primary text-brand-textLight shadow-md flex justify-between items-center">
          <h2 className="text-lg font-bold">Menu</h2>
          <button
            className="md:hidden text-sm"
            onClick={() => setSidebarOpen(false)}
          >
            ✕
          </button>
        </div> */}
        <div className="p-4 flex justify-between items-center">
          {/* <h2 className="text-lg font-bold">Menu</h2> */}
          <p className="text-lg font-bold">Kevmark Investiments</p>
          <button
            className="md:hidden text-sm"
            onClick={() => setSidebarOpen(false)}
          >
            ✕
          </button>
        </div>

        {/* Scrollable Menu */}
        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          {menuItems.map((item) => (
            <button
              key={item.key}
              // onClick={() => {
              //   setSelected(item.key);
              //   setSidebarOpen(false);
              // }}
              onClick={() => {
                setSelected(item.key);
                localStorage.setItem("selectedMenu", item.key); // Save to localStorage
                setSidebarOpen(false);
              }}
              className={`w-full text-left p-2 rounded flex items-center transition-colors duration-200 ${
                selected === item.key
                  ? "bg-brand-primary text-white font-semibold"
                  : "hover:bg-brand-muted text-brand-textDark"
              }`}
            >
              {item.icon} <span className="ml-2">{item.label}</span>
            </button>
          ))}
        </div>

        {/* Footer */}
        {/* <div className="p-4 bg-white shadow-sm flex flex-col items-start border-t border-brand-muted">
          <p className="text-sm font-semibold text-brand-textDark">
            Kevmark © 2025
          </p>
          <div className="mt-2 space-y-2 md:hidden w-full">
            <span className="text-sm font-medium text-gray-600">
              {user?.firstName}
            </span>
            <button
              onClick={handlelogout}
              className="w-full text-left px-3 py-2 bg-brand-light text-danger hover:bg-brand-muted hover:text-red-700 rounded-md flex items-center transition-all duration-200 ease-in-out"
            >
              <FaSignOutAlt size={18} className="mr-2" /> Logout
            </button>
          </div>
        </div> */}
        <div className="p-4 bg-white shadow-sm md:hidden flex flex-col items-start border-t border-brand-muted">
          <p className="text-sm font-semibold text-brand-textDark">
            Kevmark © 2025
          </p>
          <div className="mt-2 space-y-2 w-full">
            <span className="text-sm font-medium text-gray-600">
              {user?.firstName}
            </span>
            <button
              onClick={handlelogout}
              className="w-full text-left px-3 py-2 bg-brand-light text-danger hover:bg-brand-muted hover:text-red-700 rounded-md flex items-center transition-all duration-200 ease-in-out"
            >
              <FaSignOutAlt size={18} className="mr-2" /> Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-white flex flex-col h-full">
        {/* Header */}
        {/* <div className="p-4 bg-brand-light shadow-md flex items-center justify-between"> */}
        {/* <div className="p-4 flex items-center justify-between">
          <div className="flex items-center justify-between w-full">
            <h2 className="text-lg font-bold text-brand-textDark">
              Inventory Manager
            </h2>

            <div className="hidden md:flex items-center space-x-4">
              <span className="text-brand-textDark font-medium">
                {user?.firstName}
              </span>
              <button
                onClick={handlelogout}
                className="flex items-center text-danger hover:text-red-700 rounded-md"
              >
                <FaSignOutAlt size={18} className="mr-2" />
                Logout
              </button>
            </div>
          </div>

          <button
            className="md:hidden text-brand-primary"
            onClick={() => setSidebarOpen(true)}
          >
            <FaBars size={20} />
          </button>
        </div> */}

        <div className="p-4 flex items-center justify-between bg-gray-100 border-b border-gray-200">
          <div className="flex items-center justify-between w-full">
            <h2 className="text-lg font-bold text-brand-textDark">
              Inventory Manager
            </h2>

            <div className="hidden md:flex items-center space-x-4">
              <span className="text-brand-textDark font-medium">
                {user?.firstName}
              </span>
              <button
                onClick={handlelogout}
                className="flex items-center text-danger hover:text-red-700 rounded-md"
              >
                <FaSignOutAlt size={18} className="mr-2" />
                Logout
              </button>
            </div>
          </div>

          <button
            className="md:hidden text-brand-primary"
            onClick={() => setSidebarOpen(true)}
          >
            <FaBars size={20} />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-4">
          {menuItems.find((item) => item.key === selected)?.content}
        </div>
      </div>
    </div>
  );
}

export default Home;
